/* AJD · página de regalos (propuesta 22/10/2026).
   1) «Añadir a la cesta» en cualquier botón con data-ajr-add="<variante>" (buscador, exclusivas, detalles).
   2) El buscador: lee los datos que pinta Liquid en la página (solo muñecas con existencias, al momento)
      y filtra por edad, presupuesto, tamaño y cómo es. Sin peticiones al servidor para filtrar. */
(function(){
  'use strict';
  // cada sección pide este fichero; que se monte una sola vez (si no, cada clic añadiría dos)
  if (window.ajrListo) return; window.ajrListo = true;
  var euros = function(c){ return (c / 100).toFixed(2).replace('.', ',') + ' €'; };

  /* ---------- cesta ---------- */
  function cuentaCesta(){
    fetch('/cart.js', { credentials:'same-origin' }).then(function(r){ return r.json(); }).then(function(c){
      document.querySelectorAll('[data-header-cart-count],[data-cart-count]').forEach(function(n){ n.textContent = c.item_count; n.classList.remove('hidden'); });
    }).catch(function(){});
  }
  document.addEventListener('click', function(ev){
    var b = ev.target.closest('[data-ajr-add]');
    if (!b) return;
    ev.preventDefault();
    if (b.disabled) return;
    var txt = b.textContent;
    b.disabled = true; b.textContent = 'Añadiendo…';
    fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items:[{ id: +b.getAttribute('data-ajr-add'), quantity:1 }] }) })
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(){
        b.disabled = false; b.classList.add('is-hecho'); b.textContent = '✓ En su cesta';
        var ok = b.parentNode.querySelector('.ajr-card__ok');
        if (!ok){ ok = document.createElement('p'); ok.className = 'ajr-card__ok'; ok.setAttribute('role', 'status'); b.parentNode.appendChild(ok); }
        ok.innerHTML = 'Añadida. <a href="/cart">Ver la cesta</a>';
        cuentaCesta();
      })
      .catch(function(){
        b.disabled = false; b.textContent = txt;
        var ok = b.parentNode.querySelector('.ajr-card__ok') || b.parentNode.appendChild(document.createElement('p'));
        ok.className = 'ajr-card__ok'; ok.style.color = '#9A3412';
        ok.textContent = 'No se ha podido añadir. Pruebe desde la ficha o escríbanos al 623 04 44 20.';
      });
  });

  /* ---------- buscador ---------- */
  document.querySelectorAll('[data-ajr-buscador]').forEach(function(raiz){
    var DATOS = JSON.parse(raiz.querySelector('script[type="application/json"]').textContent);
    var rejilla = raiz.querySelector('.ajr-rejilla');
    var cuenta = raiz.querySelector('.ajr-cuenta');
    var limpiar = raiz.querySelector('.ajr-limpiar');
    var mas = raiz.querySelector('.ajr-mas button');
    var POR_TANDA = 6, mostradas = POR_TANDA;

    // «3 a 8 años» → [36, 108) meses; «Desde 10 meses» → [10, 48); «Más de 14 años» → [168, ∞)
    function tramo(txt){
      if (!txt) return null;
      var t = txt.toLowerCase(), n = (t.match(/\d+/g) || []).map(Number);
      var meses = function(v, unidad){ return /mes/.test(unidad) ? v : v * 12; };
      if (/^desde/.test(t) && n.length) return [meses(n[0], t), 48];
      if (/^m[aá]s de/.test(t) && n.length) return [n[0] * 12, 9999];
      if (n.length >= 2){
        var u1 = t.slice(0, t.indexOf(' a ')); // la unidad del primero va antes de « a »
        var lo = /mes/.test(u1) ? n[0] : n[0] * 12;
        return [lo, n[1] * 12 + 12];
      }
      return null;
    }
    // edad mínima del fabricante («+24 meses», «+3 años»): una muñeca nunca sale para una edad por debajo de ella
    function minima(txt){
      var n = txt && txt.match(/\d+/);
      if (!n) return null;
      return /mes/i.test(txt) ? +n[0] : +n[0] * 12;
    }
    DATOS.forEach(function(r){ r.a = tramo(r.e); r.min = minima(r.m); });

    // encaja si su edad ideal se solapa con el tramo y la mínima del fabricante no pasa del principio del tramo
    var entre = function(lo, hi){ return function(r){ return r.a && r.a[0] < hi && r.a[1] > lo && (r.min === null || r.min <= lo); }; };
    var EJES = {
      e: [ ['Menos de 2 años', entre(10, 24)], ['2 años', entre(24, 36)], ['3 a 5 años', entre(36, 72)],
           ['6 a 9 años', entre(72, 120)], ['10 años o más', entre(120, 9999)] ],
      p: [ ['Hasta 40 €', function(r){ return r.p <= 4000; }], ['40 a 55 €', function(r){ return r.p > 4000 && r.p <= 5500; }],
           ['55 a 70 €', function(r){ return r.p > 5500 && r.p <= 7000; }], ['Más de 70 €', function(r){ return r.p > 7000; }] ],
      c: [ ['Pequeña, hasta 30 cm', function(r){ return r.c && r.c <= 30; }], ['Mediana, 31 a 40 cm', function(r){ return r.c > 30 && r.c <= 40; }],
           ['Grande, 41 a 46 cm', function(r){ return r.c > 40 && r.c <= 46; }], ['Muy grande, más de 46 cm', function(r){ return r.c > 46; }] ],
      t: [ ['Blandita, para abrazar', function(r){ return /blando|tejido/i.test(r.b || ''); }],
           ['De vinilo', function(r){ return /vinilo|silicona|articulad/i.test(r.b || ''); }],
           ['Llora o habla', function(r){ return !!r.s; }],
           ['Reborn, muy realista', function(r){ return r.f === 'Reborn'; }] ]
    };
    var elegido = { e:null, p:null, c:null, t:null };

    Object.keys(EJES).forEach(function(k){
      var caja = raiz.querySelector('.ajr-opts[data-eje="' + k + '"]');
      EJES[k].forEach(function(op, i){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ajr-opt'; b.textContent = op[0]; b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function(){
          elegido[k] = elegido[k] === i ? null : i;
          Array.prototype.forEach.call(caja.children, function(o, j){ o.setAttribute('aria-pressed', elegido[k] === j ? 'true' : 'false'); });
          mostradas = POR_TANDA; pinta();
        });
        caja.appendChild(b);
      });
    });

    function filtra(sin){
      return DATOS.filter(function(r){
        return Object.keys(elegido).every(function(k){
          if (elegido[k] === null || k === sin) return true;
          return EJES[k][elegido[k]][1](r);
        });
      });
    }
    function hay(){ return Object.keys(elegido).some(function(k){ return elegido[k] !== null; }); }

    function tarjeta(r){
      var d = [];
      if (r.c) d.push(r.c + ' cm');
      if (r.e) d.push(r.e);
      var a = document.createElement('div');
      a.className = 'ajr-card';
      a.innerHTML =
        '<a class="ajr-card__foto" href="/products/' + r.h + '" tabindex="-1" aria-hidden="true"></a>' +
        '<a class="ajr-card__n" href="/products/' + r.h + '"></a><p class="ajr-card__d"></p>' +
        '<p class="ajr-card__p">' + euros(r.p) + (r.pc > r.p ? '<s>' + euros(r.pc) + '</s>' : '') +
        (r.q > 0 && r.q <= 3 ? '<span class="ajr-card__ult">Quedan ' + r.q + '</span>' : '') + '</p>' +
        '<button type="button" class="ajr-btn" data-ajr-add="' + r.v + '">Añadir a la cesta</button>';
      var img = new Image(400, 400);
      img.loading = 'lazy'; img.alt = ''; img.src = r.i;
      a.querySelector('.ajr-card__foto').appendChild(img);
      a.querySelector('.ajr-card__n').textContent = r.t;
      a.querySelector('.ajr-card__d').textContent = d.join(' · ');
      return a;
    }

    function pinta(){
      var lista = filtra(null);
      limpiar.hidden = !hay();
      cuenta.innerHTML = hay()
        ? '<b>' + lista.length + '</b> ' + (lista.length === 1 ? 'muñeca encaja' : 'muñecas encajan') + ', todas con existencias hoy'
        : '<b>' + DATOS.length + '</b> muñecas con existencias hoy. Empezamos por las que más se piden.';
      rejilla.innerHTML = '';
      if (!lista.length){ vacio(); mas.parentNode.hidden = true; return; }
      lista.slice(0, mostradas).forEach(function(r){ rejilla.appendChild(tarjeta(r)); });
      var quedan = lista.length - mostradas;
      mas.parentNode.hidden = quedan <= 0;
      mas.textContent = 'Ver ' + Math.min(quedan, POR_TANDA) + ' más (quedan ' + quedan + ')';
    }

    // sin resultados: qué respuesta soltar para que salgan, con cuántas saldrían
    function vacio(){
      var ideas = Object.keys(elegido).filter(function(k){ return elegido[k] !== null; })
        .map(function(k){ return { k:k, n:filtra(k).length }; })
        .filter(function(i){ return i.n; }).sort(function(a, b){ return b.n - a.n; });
      var div = document.createElement('div');
      div.className = 'ajr-vacio';
      div.innerHTML = '<p><b>Así, tal cual, no tenemos ninguna con existencias.</b></p><p>Quite una respuesta y le enseñamos las que hay:</p><div class="ajr-ideas"></div>' +
        '<p><a class="ajr-wa" href="https://wa.me/34623044420">O pregúntenos por WhatsApp y se la buscamos</a></p>';
      ideas.slice(0, 3).forEach(function(i){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ajr-btn ajr-btn--suave';
        b.textContent = 'Sin «' + EJES[i.k][elegido[i.k]][0] + '»: ' + i.n;
        b.addEventListener('click', function(){
          elegido[i.k] = null;
          raiz.querySelectorAll('.ajr-opts[data-eje="' + i.k + '"] .ajr-opt').forEach(function(o){ o.setAttribute('aria-pressed', 'false'); });
          pinta();
        });
        div.querySelector('.ajr-ideas').appendChild(b);
      });
      rejilla.appendChild(div);
    }

    mas.addEventListener('click', function(){ mostradas += POR_TANDA; pinta(); });
    limpiar.addEventListener('click', function(){
      Object.keys(elegido).forEach(function(k){ elegido[k] = null; });
      raiz.querySelectorAll('.ajr-opt').forEach(function(o){ o.setAttribute('aria-pressed', 'false'); });
      mostradas = POR_TANDA; pinta();
    });
    pinta();
  });
})();
